<template lang="pug">
nuxt-link.link(
  v-bind="$attrs"
  :to="props.link"
  @click.prevent="handleRedirect"
)
  span(v-if="props.text") {{ props.text }}
  slot
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { type RedirectPatternProps } from './RedirectPattern.types';
import { redirectPatternDefaults } from './RedirectPattern.defaults';

const props = withDefaults(
  defineProps<RedirectPatternProps>(),
  redirectPatternDefaults as any,
) as unknown as RedirectPatternProps;
const router = useRouter();

function handleRedirect() {
  if (props.condition && !props.condition()) {
    return;
  }

  if (props.redirectDelay) {
    setTimeout(() => {
      router.push(props.link);
    }, props.redirectDelay);
  } else {
    router.push(props.link);
  }
}
</script>
